import useOperatorsTable from './useOperatorsTable'
import OperatorsTableBody from './OperatorsTableBody/OperatorsTableBody'
import { ActionsTh, Table, TableWrap, Th, TheadRow } from './styled-components'

interface OperatorsTableProps {
  hidden: boolean
}

const OperatorsTable = ({ hidden }: OperatorsTableProps) => {
  const { t, rows, isSubmitting } = useOperatorsTable()

  if (hidden) return null

  return (
    <TableWrap>
      <Table>
        <thead>
          <TheadRow>
            <Th>{t('breakManagement:table.name')}</Th>
            <Th>{t('breakManagement:table.department')}</Th>
            <Th>{t('breakManagement:table.started_at')}</Th>
            <ActionsTh>{t('breakManagement:table.actions')}</ActionsTh>
          </TheadRow>
        </thead>
        <tbody>
          <OperatorsTableBody
            rows={rows}
            isSubmitting={isSubmitting}
            emptyText={t('breakManagement:table.empty')}
            forceStopLabel={t('breakManagement:table.force_stop')}
          />
        </tbody>
      </Table>
    </TableWrap>
  )
}

export default OperatorsTable
